/* eslint-disable */
import tlds from 'tlds';

export const TLDs = tlds.join('|');
export const EMAIL_PATTERN = new RegExp(`^[a-z0-9_\`'\\-\\+\\&+]+(\\.[_a-z0-9'\\-\\+]+)*@([_a-z0-9\\-]+\\.)+([a-z]{2}|${TLDs})$`, 'i');
